import { createSlice } from "@reduxjs/toolkit";
import { getDepartment } from "../reduxApi/departmentReduxApi";

const departmentSlice = createSlice({
    name: 'department',
    initialState: {
    status: 'idel',
    department: [],
    },
    reducers: {
        deleteDepartmentAction: (state, action) => {
            action.payload.forEach((id) => {
                const index = state.department.findIndex((item) => item.rowId === id);
                if (index !== -1) {
                    state.department.splice(index, 1);
                }
            });
        },     
        updateDepartmentAction: (state, action) => {
            console.log("action", action.payload)
            const index = state.department.findIndex((item) => item.rowId === action.payload.ROWID)
            if (index != -1) {
                state.department.splice(index, 1, action.payload )
            }
        },
        addDepartmentAction: (state, action) => {
            const temp = action.payload.formData;
            temp.ROWID = action.payload.ROWID;
            state.department.unshift(temp);
        }
    },
    extraReducers: (builder) => {
        builder.addCase(getDepartment.pending, (state, action) => {
            state.status = 'pending'
        })
            .addCase(getDepartment.fulfilled, (state, action) => {
                state.status = 'fulfilled'
                console.log("departmentSlice", action.payload)
                state.department = action.payload.data.departments;
            })
    }
})
export const { deleteDepartmentAction, updateDepartmentAction, addDepartmentAction } = departmentSlice.actions
export default departmentSlice.reducer